import * as React from 'react';
import { Icon } from '@alifd/next';
import { history } from 'ice';
import styles from './index.module.scss';

const SolutionLink = () => (
  <>
  <div className={styles.link}>
    {/* <Link to="/mobile/home" title="切換App頁面"> */}
      <Icon type="smile" className={styles.icon} onClick={
        ()=>{
          history.push('/mobile/home')
        }
      }/>
    {/* </Link> */}
  </div>
  <div className={styles.link}>
    {/* <Link to="/mobile/home" title="切換App頁面"> */}
      <Icon type="search" className={styles.icon} onClick={
        ()=>{
          window.location.href='../../account';
        }
      }/>
    {/* </Link> */}
  </div>
</>);

export default SolutionLink;
